import TabFilters from './TabFilters';

export default TabFilters;
